import React from "react";

import { IProductTemplateTableEditor } from "components/ComponentTypeTypes";
import { InputNumber, InputNumberValueChangeEvent } from "primereact/inputnumber";
import { InputSwitchChangeEvent } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import { T } from "services/lang/LanguageService";
import ProductTemplateColumnsDropdown from "components/basic/dropdowns/product-template-columns-dropdown/ProductTemplateColumnsDropdown";
import TimeSpanInputs from "components/fragments/product-template-configurator/ProductTemplateAttributesConfiguration/type-fields/components/TimeSpanInputs";

type ProductTemplateConfigProps = {
  currentConfig: IProductTemplateTableEditor;
  setCurrentConfig: React.Dispatch<React.SetStateAction<IProductTemplateTableEditor>>;
};

const ProductTemplateConfig: React.FC<ProductTemplateConfigProps> = ({
  currentConfig,
  setCurrentConfig,
}) => {
  const handleConfigChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | InputNumberValueChangeEvent
      | InputSwitchChangeEvent
      | MultiSelectChangeEvent
  ) => {
    setCurrentConfig(prevState => ({ ...prevState, [e.target.id]: e.target.value }));
  };

  return (
    <div className="flex flex-column gap-2">
      <div className="w-full flex flex-wrap md:flex-nowrap gap-2 mb-3">
        <div className="w-full md:w-3 gap-2 flex flex-column justify-content-center">
          <label htmlFor="filter">{T("word.hidden-filter")}</label>
          <InputText
            id="filter"
            value={currentConfig?.filter ?? ""}
            onChange={handleConfigChange}
          />
        </div>
        <div className="w-full md:w-3 gap-2 flex flex-column justify-content-center">
          <label htmlFor="defaultFilter">{T("word.default-filter")}</label>
          <InputText
            id="defaultFilter"
            value={currentConfig?.defaultFilter ?? ""}
            onChange={handleConfigChange}
          />
        </div>
        <div className="w-5 md:w-2 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="itemsPerPage">{T("component.items-per-page")}</label>
          <InputNumber
            id="itemsPerPage"
            value={currentConfig?.itemsPerPage}
            onValueChange={handleConfigChange}
          />
        </div>
        <div className="w-5 md:w-2 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="updateFrequency">{T("load-conf.update-frequency")}</label>
          <div className="p-inputgroup">
            <InputNumber
              id="updateFrequency"
              value={currentConfig?.updateFrequency as number}
              onValueChange={handleConfigChange}
            />
            <span className="p-inputgroup-addon">s</span>
          </div>
        </div>
      </div>
      <div className="w-full flex flex-wrap md:flex-nowrap gap-3 mb-3">
        <div className="w-full md:w-3 gap-2 flex flex-column justify-content-center">
          <label htmlFor="hiddenColumns">{T("component.hidden-columns")}</label>
          <ProductTemplateColumnsDropdown
            id="hiddenColumns"
            value={Array.isArray(currentConfig.hiddenColumns) ? currentConfig.hiddenColumns : []}
            className="w-full"
            onChange={handleConfigChange}
            selectedTemplate={{
              refName: currentConfig.safeName,
              value: currentConfig.id!,
            }}
          />
        </div>
        <div className="w-full md:w-3 gap-2 flex flex-column justify-content-center">
            <label>{`${T("word.datasets")} ${T("word.max")} ${T("word.age").toLowerCase()}`}</label>
            <div className="p-inputgroup">
              <TimeSpanInputs
                value={currentConfig.maxAge ?? 0}
                onChange={val => setCurrentConfig({ ...currentConfig, maxAge: val })}
              />
            </div>
          </div>
      </div>
    </div>
  );
};

export default ProductTemplateConfig;
